import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { useFetchingContactDetails } from "Bands/utils";
import { copy } from "shared/assets";
import { ContactTeaser, Loader, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { GridContainer } from "shared/styles";

const phoneCopy = copy.userPhoneNumber;

export const PhoneNumbers: FC = () => {
  const { phoneNumbers } = useFullUserProfileContext();
  const { fetchingPhoneNumbers } = useFetchingContactDetails();

  if (fetchingPhoneNumbers) return <Loader />;
  if (!phoneNumbers?.length) return null;

  return (
    <Spacer size="m">
      <Title title={phoneCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {phoneNumbers?.map(phoneNumber => (
          <ContactTeaser
            id={phoneNumber.id}
            key={phoneNumber.id}
            phone={phoneNumber.phoneNumber}
            note={phoneNumber.note}
          />
        ))}
      </GridContainer>
    </Spacer>
  );
};
